import { useCallback, useEffect, useRef } from 'react';
const useIsMounted = () => {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
    return function cleanup() {
      isMounted.current = false;
    };
  }, []);
  const isComponentMounted = useCallback(() => {
    return isMounted.current;
  }, []);
  return isComponentMounted;
};
export default useIsMounted;